import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
export const Proof = () => {
  return <section className="py-16 md:py-20 bg-brand-green/5 relative overflow-hidden" data-id="element-165">
      <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-166"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-surface/80 backdrop-blur-sm border border-brand-green/20 p-6 sm:p-8 md:p-12 rounded-2xl text-center shadow-[0_0_50px_rgba(16,185,129,0.1)]" data-id="element-168">
          <Activity className="w-10 h-10 md:w-12 md:h-12 text-brand-green mx-auto mb-4 md:mb-6" data-id="element-169" />

          <h3 className="text-xl sm:text-2xl md:text-3xl text-white mb-4 md:mb-6 leading-tight" data-id="element-170">
            En las próximas 7 días, tu métrica de éxito no será cuánto ganaste,
            sino{' '}
            <span className="text-brand-green" data-id="element-171">
              cuántas operaciones emocionales no tomaste.
            </span>
          </h3>

          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-172">
            Verás cómo tu curva de capital deja de caer en picado y comienza a
            estabilizarse, eliminando el estrés que hoy no te deja dormir.
          </p>
        </motion.div>
      </div>
    </section>;
};